import React, { PureComponent } from 'react';

const COLORS = ['#ff6b6b', '#feca57', '#48dbfb', '#ff9ff3', '#54a0ff', '#5f27cd', '#01a3a4', '#f368e0'];
const PARTICLE_COUNT = 60;

class ConfettiBurstAnimation extends PureComponent {
    constructor(props) {
        super(props);
        this.particles = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
            id: i,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            left: Math.random() * 100,
            delay: Math.random() * 0.5,
            duration: 2 + Math.random() * 1.5,
            size: 6 + Math.random() * 8,
            rotation: Math.random() * 360,
            drift: (Math.random() - 0.5) * 60,
        }));
    }

    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                {this.particles.map(p => (
                    <div
                        key={p.id}
                        style={{
                            ...styles.particle,
                            backgroundColor: p.color,
                            left: `${p.left}%`,
                            width: p.size,
                            height: p.size * 0.6,
                            animationDelay: `${p.delay}s`,
                            animationDuration: `${p.duration}s`,
                            '--drift': `${p.drift}px`,
                            '--rotation': `${p.rotation}deg`,
                        }}
                    />
                ))}
            </div>
        );
    }
}

const keyframes = `
@keyframes confetti-fall {
    0% { transform: translateY(-10px) translateX(0) rotate(0deg); opacity: 1; }
    100% { transform: translateY(100vh) translateX(var(--drift)) rotate(var(--rotation)); opacity: 0; }
}
`;

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
    },
    particle: {
        position: 'absolute',
        top: -10,
        borderRadius: 2,
        animation: 'confetti-fall linear forwards',
    },
};

export default ConfettiBurstAnimation;
